import focusEducation from '../assets/icons/partner/focus-education.png'
import focusHealth from '../assets/icons/partner/focus-health.png'
import focusEnvironment from '../assets/icons/partner/focus-environment.png'
import focusDemocracy from '../assets/icons/partner/focus-democracy.png'
import focusSpirituality from '../assets/icons/partner/focus-spirituality.png'
import focusFitness from '../assets/icons/partner/focus-fitness.png'
import focusStudentWelfare from '../assets/icons/partner/focus-student-welfare.png'

export const partnerHero = {
  title: 'Partner With Us',
  subtitle:
    'Collaborate with us to empower youth, strengthen communities, and create lasting social impact.',
  cta: 'Partner With Us Today',
  ctaLink: '/contact',
}

export const togetherSection = {
  title: 'Together, We Can Create\nGreater Impact',
  text:
    'Disha Foundation believes that meaningful change happens through collaboration. We welcome organizations, educational institutions, businesses, community groups, and individuals who share our vision of empowering youth and building a stronger society. By partnering with us, you can contribute to initiatives that foster leadership, education, community development, and social responsibility.',
}

export const whyPartner = {
  title: 'Why Partner With Disha Foundation?',
  items: [
    'Support youth empowerment and leadership development',
    'Create a positive impact in communities',
    'Collaborate on social and educational initiatives',
    'Strengthen corporate social responsibility (CSR) efforts',
    'Engage employees, students, and communities in meaningful programs',
    'Contribute to nation-building through collective action',
  ],
  titleMaxWidth: { md: 432, lg: 432 },
}

export const whoCanPartner = {
  title: 'Who Can Partner With Us?',
  items: [
    'Educational Institutions',
    'Corporate Organizations',
    'NGOs & Non-Profit Organizations',
    'Government & Community Bodies',
    'Professional Associations',
    'Individual Donors & Supporters',
  ],
  titleMaxWidth: { md: 316, lg: 316 },
}

export const focusAreas = [
  {
    title: 'Education',
    description: 'Empowering youth through education, leadership, and values.',
    iconSrc: focusEducation,
    iconBgColor: 'rgba(183,7,7,0.12)',
    path: '/dimensions/education',
  },
  {
    title: 'Health',
    description: 'Promoting physical, mental, and social well-being for a healthier society.',
    iconSrc: focusHealth,
    iconBgColor: 'rgba(183,142,7,0.12)',
    path: '/dimensions/health',
  },
  {
    title: 'Environment',
    description:
      'Encouraging environmental awareness and sustainable practices for a better future.',
    iconSrc: focusEnvironment,
    iconBgColor: 'rgba(115,183,7,0.12)',
    path: '/dimensions/environment',
  },
  {
    title: 'Democracy',
    description: 'Encouraging civic responsibility and nation-building participation.',
    iconSrc: focusDemocracy,
    iconBgColor: 'rgba(7,183,183,0.12)',
    path: '/dimensions/democracy',
  },
  {
    title: 'Spirituality',
    description:
      'Nurturing inner growth, moral values, and cultural consciousness among youth.',
    iconSrc: focusSpirituality,
    iconBgColor: 'rgba(7,30,183,0.12)',
    path: '/dimensions/spirituality',
  },
  {
    title: 'Fitness',
    description: 'Building confidence and discipline through fitness and active living.',
    iconSrc: focusFitness,
    iconBgColor: 'rgba(183,7,171,0.12)',
    path: '/dimensions/fitness',
  },
  {
    title: 'Student Welfare',
    description: 'Supporting students through guidance, mentorship, and growth.',
    iconSrc: focusStudentWelfare,
    iconBgColor: 'rgba(8,39,83,0.12)',
    path: '/dimensions/student-welfare',
  },
]

export const benefitsPartnership = {
  title: 'Benefits Of Partnership',
  items: [
    'Meaningful Social Impact',
    'Increased Community Engagement',
    'Brand Visibility & Recognition',
    'Access To Youth Development Programs',
    'Collaborative Growth Opportunities',
    'Contribution To Sustainable Community Development',
  ],
  titleMaxWidth: { md: 276, lg: 276 },
}
